<template>
  <div class="role_wrapper">
    <div style="margin-bottom:20px;">
      <el-button v-auth="'sys:role:add'" @click="handleEdit('',0)" type="primary" icon="el-icon-plus">{{$t('role.addRole')}}</el-button>
    </div>
    <el-table
    v-loading="loading"
      :row-class-name="tableRowClassName"
      border
      :data="roleListData"
      style="width: 100%"
    >
      <el-table-column :label="$t('common.date')" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ scope.row.createDate}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('role.role')" width="180">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>{{$t('role.role')}}: {{ scope.row.roleName }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium">{{ scope.row.roleName }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.remark')" width="180">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>{{$t('common.remark')}}: {{ scope.row.remark }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium">{{ scope.row.remark }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="公司名称" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.companyName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.handle')">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handlePermission(scope.$index, scope.row)"
            v-auth="'sys:role:check'"
          >{{$t('role.menuControl')}}</el-button>
          <el-button
            size="mini"
            @click="handleColumnAuth(scope.$index, scope.row)"
            v-auth="'sys:role:check'"
          >{{$t('role.columnAuth')}}</el-button>
          <el-button
            size="mini"
            v-show="scope.row.role != 'SYS_ALL'"
            @click="handleEdit(scope.row,1)"
            v-auth="'sys:role:edit'"
          >{{$t('common.edit')}}</el-button>
          <el-button
            size="mini"
            v-show="scope.row.role != 'SYS_ALL'"
            type="danger"
            v-auth="'sys:role:delete'"
            @click="handleDelete(scope.$index, scope.row)"
          >{{$t('common.delete')}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑弹窗 -->
    <el-dialog :title="titleName" :visible.sync="showEditBox" v-if="showEditBox">
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item
          v-if="roleSys"
          :label="$t('user.companyChoice')"
          :label-width="formLabelWidth"
          prop="companyId"
        >
          <el-select

            v-model="form.companyId"
            :placeholder="$t('user.companyChoice')"
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('role.roleName')" prop="roleName" :label-width="formLabelWidth">
          <el-input v-model="form.roleName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.remark')" prop="remark" :label-width="formLabelWidth">
          <el-input v-model="form.remark" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditBox = false">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="submitData('form')">{{$t('common.ok')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="$t('role.menuControl')" :visible.sync="menuRoleBox">
      <el-tree
        :data="menuroleListData"
        :props="defaultProps"
        ref="menuListTree"
         v-loading="loading"
        show-checkbox
        node-key="id"
        :default-expanded-keys="expandKeys"
        :default-checked-keys="checkedKey"
        :expand-on-click-node="false"
      ></el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button @click="menuRoleBox = false">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="submitRoleData">{{$t('common.ok')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="'列权限控制'" :visible.sync="columnRoleBox">
      <el-transfer
        v-loading="loading"
        v-model="selectedColumns"
        :data="allColumns"
        :titles="['可选列', '已屏蔽列']"
        :button-texts="['撤销', '屏蔽']"
        filterable
        filter-placeholder="请输入列名搜索">
      </el-transfer>
      <div slot="footer" class="dialog-footer">
        <el-button @click="columnRoleBox = false">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="submitColumnData">{{$t('common.ok')}}</el-button>
      </div>
    </el-dialog>
    <div style="margin-top:20px;text-align:right">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10,20,50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  roleList,
  editRoleList,
  addRoleList,
  delRoleList,
  recuRoleList,
  editRolePer,
  getRoleColumnAuthInfo,
  editRoleColumnAuth,
  addRoleColumnAuth
} from "@/api/sys/roleList";
import { getAllNode, getAllKey } from "@/utils/tree.js";
import { Message } from "element-ui";
import { localRead,localSave } from "@/utils/tools";
import { permission } from "@/api/user";
import { companyListAll } from "@/api/sys/companyList";
import { addSysRouter } from "@/router/permission";
export default {
  data() {
    return {
      userInfo: JSON.parse(
        localRead(this.$route.query.label + "_sys_userInfo")
      ),
      loading:true,
      roleListData: [],
      showEditBox: false,
      formLabelWidth: "120px",
      changeType: 1,
      currentPage: 1,
      pageSize: 10,
      titleName: this.$t("role.editRoleName"),
      totalSize: 0,
      form: {
        id: "",
        roleName: "",
        remark: "",
        companyId: ""
      },
      rules: {
        companyId: [
          { required: true, message: "请选择公司", trigger: "change" }
        ],
        roleName: [
          { required: true, message: "角色名称不能为空", trigger: "blur" }
        ],
        remark: [{ required: true, message: "备注不能为空", trigger: "blur" }]
      },
      menuRoleBox: false,
      menuroleListData: [],
      checkedKey: [],
      expandKeys: [],
      roleId: "",
      errorInfo: false,
      defaultProps: {
        children: "children",
        label: "label"
      },
      companyList: "", // 公司列表
      roleSys: false, //公司选项是否出现
      columnRoleBox: false, // 列权限弹窗
      allColumns: [
            { key: 'phoneNumber', label: '电话' },
            { key: 'email', label: '邮箱' },
              { key: 'docNumber', label: '证件号码' }
          ], // 所有可用列
      selectedColumns: [] // 已授权列
    };
  },
  created() {
    if (this.userInfo.isBy) {
      this.roleSys = true;
    } else {
      this.roleSys = false;
    }
  },
  mounted() {
    this.getCompanyList();
    this.getRoleList();
  },
  methods: {

    getCompanyList() {
      companyListAll().then(res => {
        this.companyList = res.result;

      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    getRoleList() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage
      };
      roleList(data).then(res => {
        if (res.code == 0) {
          this.roleListData = res.result.list;
          this.totalSize = res.result.total;
           this.loading = false
        }
      });
    },
    handleEdit(row, type) {
      let updateObject;
      updateObject = Object.assign({},row);
      this.changeType = type;
      if (this.changeType == 1) {
        this.form = updateObject ;
        this.titleName = this.$t("role.editRoleName");
      } else if (this.changeType == 0) {

        for (let key in this.form) {
          this.form[key] = "";
        }
        this.titleName = this.$t("role.addRole");
      }
      this.showEditBox = true;
    },
    submitData(fromName) {
      this.$refs[fromName].validate(valid => {
        if (valid) {
          if (this.changeType == 1) {
            editRoleList(this.form).then(res => {
              if (res.code == 0) {
                Message({
                  message: this.$t("common.changeSu"),
                  type: "success"
                });
              }
              this.getRoleList();
            });
          } else {
            addRoleList(this.form).then(res => {
              if (res.code == 0) {
                Message({
                  message: this.$t("common.addSu"),
                  type: "success"
                });
              }
              this.getRoleList();
            });
          }
           this.showEditBox = false;
        }else{
          return false
        }
      });
    },
    submitColumnData() {
      this.loading = true;
      let data = {
        roleId: this.roleId,
        viewColumns: this.selectedColumns.join(',')
      };

      let apiCall;
      if (this.columnAuthId) {
        // 修改已有记录
        data.id = this.columnAuthId;
        apiCall = editRoleColumnAuth(data);
      } else {
        // 新增记录
        apiCall = addRoleColumnAuth(data);
      }

      apiCall.then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '列权限更新成功'
          });
          this.columnRoleBox = false;
        }
        this.loading = false;
      })
    },
    handleDelete(index, row) {
      this.$confirm(this.$t("common.ifDelete"), this.$t("common.tip"), {
        confirmButtonText: this.$t("common.ok"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delRoleList(row.id).then(res => {
              if (res.code == 0) {
                 this.$message({
                  type: "success",
                  message: this.$t("common.conDelete")
                });
                this.getRoleList();
              }
            });
            done();
          } else{
            done()
          }
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: this.$t("common.canDele")
        });
      });
    },
    // 递归判断子节点
    checkPermTree(permData) {
      let that = this;
      let lang = "en";
      if (localRead("language")) {
        lang = localRead("language");
      }
      permData.forEach(function(p, index) {
        let label = JSON.parse(p.label);
        p.label = label[lang];
        // //暂时剔除掉按钮
        // if (p.type == 2) {
        //   permData.splice(index, 1);
        // }
        if (p.children && p.children.length > 0) {
          that.checkPermTree(p.children);
        }
      });
    },
    handlePermission(index, row) {
      this.expandKeys = [];
      this.roleId = row.id;
       this.loading = true
      recuRoleList(row.id).then(res => {
        if (res.code == 0) {
          let data = res.result;
          let lang = "en";
          if (localRead("language")) {
            lang = localRead("language");
          }
          this.checkPermTree(data);

          this.menuroleListData = data;
          this.loading = false
          this.expandKeys = getAllNode(this.menuroleListData, "id", "children");

          this.$refs.menuListTree.setCheckedKeys(
            getAllKey(this.menuroleListData, "id", "children"),
            true
          );
        }
      });
      this.menuRoleBox = true;
    },handleColumnAuth(index, row) {
      this.columnRoleBox = true;
      this.roleId = row.id;
      this.columnAuthId = null; // 初始化为null，表示新增

      getRoleColumnAuthInfo({roleId:row.id}).then(res => {
        if (res.code == 0 && res.result!=null) {
          this.columnAuthId = res.result.id; // 设置ID，表示修改
          let viewColumns = res.result.viewColumns;
          this.selectedColumns = viewColumns.split(',');
        } else {
          this.selectedColumns = [];
        }
        this.loading = false;
      })
    },
    async submitRoleData() {
      let data = {
        permissionIds: this.$refs.menuListTree
          .getCheckedKeys()
          .concat(this.$refs.menuListTree.getHalfCheckedKeys()),
        roleId: this.roleId
      };
      await editRolePer(data).then(res => {
        if (res.code == 0) {
          Message({
            message: this.$t("common.changeSu"),
            type: "success"
          });
          this.menuRoleBox = false;
        }
      });
      // this.updateMenu();
    },
    updateMenu() {
      let _this = this;
      permission().then(res => {
        let  getRouter = res.result[0].children[0].children
         addSysRouter(getRouter,this.$route.query.label);
      });
    },
    saveObjArr(name, data) {
      localStorage.setItem(name, JSON.stringify(data));
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getRoleList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getRoleList();
    }
  }
};
</script>
<style lang="scss" scoped>
.role_wrapper {
  margin: 50px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  padding: 20px;
}
.role_wrapper:hover {
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
    0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
